module.exports = __webpack_public_path__ + "static/media/blog-gear.e5b9c37d.jpg";